export default "__VITE_ASSET__m5FL8J0a__"